enum EnumPaymentGateway {
    ECPay = "ECPay",
    NewebPay = "NewebPay", 
    PayPal = "PayPal", 
    OnSite = "OnSite"
}

export default EnumPaymentGateway;